import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const Reports = (function() {
  function get() {
    if (logComponent('Reports')) { console.debug('Reports get'); }
    return axios.get('api/Reports', getConfig());    
  }

  function reportName(reportName) {
    if (logComponent('Reports')) { console.debug('Reports reportName'); }
      return axios.get(`api/Reports/${reportName}`, getConfig());
  }

  function getReportToken(reportId) {
    if (logComponent('Reports')) { console.debug('Reports getReportToken'); }
      const params = { reportId };
      return axios.get(`api/Reports/GetTokenFor`, getConfig( params));
  }

  return {
    get,
    reportName,
    getReportToken
  }
})();

export default Reports;